// components/dashboard/RevenueChart.jsx
import React from 'react';

const RevenueChart = ({ data }) => {
    return (
        <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium mb-4">收入統計</h3>
            <div className="h-60 flex items-center justify-center bg-gray-100 rounded">
                <p className="text-gray-500">收入圖表將在此處顯示</p>
            </div>
        </div>
    );
};

export default RevenueChart;